/**
 * CSV / Excel import dialog. Pure view: account dropdown + file input +
 * template-download link + submit/cancel. Tier-gate upsell is handled
 * by the shell (lifts the gate detail from useTransactions, opens a
 * separate TierGate.Dialog when set).
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Button } from '../../components/ui/button';

const ImportDialog = ({
  open, onOpenChange,
  accounts, importAccountId, setImportAccountId,
  importFile, handleFileChange, fileInputRef,
  handleImport, downloadTemplate,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-white">
      <DialogHeader>
        <DialogTitle className="text-2xl font-bold text-[#020617]">Import Transactions</DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <div>
          <Label>Select Account</Label>
          <Select value={importAccountId} onValueChange={setImportAccountId}>
            <SelectTrigger className="mt-1.5" data-testid="import-account-select">
              <SelectValue placeholder="Choose account" />
            </SelectTrigger>
            <SelectContent>
              {accounts.map((acc) => (
                <SelectItem key={acc.account_id} value={acc.account_id}>
                  {acc.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label>Upload CSV or Excel File</Label>
          <p className="text-xs text-[#64748B] mt-1 mb-2">File should have columns: date, description, amount, type, category</p>
          <button
            type="button"
            onClick={downloadTemplate}
            className="text-xs font-medium text-[#0052FF] hover:text-[#003ECC] underline-offset-2 hover:underline mb-2 inline-flex items-center gap-1"
            data-testid="download-template-button"
          >
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" /></svg>
            Download CSV template
          </button>
          <Input type="file" accept=".csv,.xlsx,.xls" onChange={handleFileChange} ref={fileInputRef} className="mt-1.5" data-testid="import-file-input" />
          {importFile && <p className="text-sm text-[#64748B] mt-2">Selected: {importFile.name}</p>}
        </div>
        <div className="flex gap-3 pt-4">
          <Button onClick={handleImport} className="flex-1 bg-[#0052FF] text-white hover:bg-[#003ECC]" data-testid="import-submit-button">
            Import
          </Button>
          <Button onClick={() => onOpenChange(false)} className="flex-1 bg-[#F1F5F9] text-[#020617] hover:bg-[#E2E8F0]">
            Cancel
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export default ImportDialog;
